module.exports = __webpack_public_path__ + "img/Modernisme_Episke_forfattere1.eb74778c.jpg";